import React, { useState } from "react";

const QueryForm = ({ onClose }) => {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const payload = {
      name,
      phone,
      email,
      message
    };

    try {
      const res = await fetch(
        "https://infobizz.website/api/add-query.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(payload)
        }
      );

      const data = await res.json();

      if (data.success) {
        setSubmitted(true);
        setName("");
        setPhone("");
        setEmail("");
        setMessage("");
      } else {
        alert("Something went wrong. Please try again.");
      }
    } catch (err) {
      alert("Server error. Please try again later.");
    }

    setLoading(false);
  };

  return (
    <div className="modal-overlay">
      <div className="modal-box">
        <button className="modal-close" onClick={onClose}>×</button>

        {!submitted ? (
          <>
            <h2>Start Your Project</h2>
            <p>Please share your requirements.</p>

            <form className="query-form" onSubmit={handleSubmit}>
              <input
                type="text"
                placeholder="Your Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />

              <input
                type="tel"
                placeholder="Phone Number"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                required
              />

              <input
                type="email"
                placeholder="Email Address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />

              <textarea
                placeholder="Project details / Suggestions"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              />

              <button type="submit" className="cta-btn" disabled={loading}>
                {loading ? "Submitting..." : "Submit Query"}
              </button>
            </form>
          </>
        ) : (
          <>
            <h2>Thank You 🎉</h2>
            <p>
              Your request has been received.  
              Our team will contact you shortly.
            </p>

            <button className="cta-btn" onClick={onClose}>
              Close
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default QueryForm;
